import { render, staticRenderFns } from "./LegalDocumentFormDetailsBox.vue?vue&type=template&id=501c03bc&scoped=true&"
import script from "./LegalDocumentFormDetailsBox.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFormDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentFormDetailsBox.vue?vue&type=style&index=0&id=501c03bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c03bc",
  null
  
)

export default component.exports